import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RichTextEditorService {

  private editorContentSubject = new BehaviorSubject<string>('');

  setEditorContent(content: string) {
    this.editorContentSubject.next(content);

  }

  getEditorContent(): Observable<string> {
    return this.editorContentSubject.asObservable();
  }

  setCotentfromComponent(content:any): any {
    return content;
  }
}
